import { TZ_PLUS_COPY } from '../../config/tzPlus/stops';
import TzPlusHero from './TzPlusHero';
import WelcomeModalLayout from './WelcomeModalLayout';

interface TzPlusWelcomeModalProps {
  onStart: () => void;
  mascotSrc: string;
}

/**
 * The TZ+ tour's opening modal. Same skeleton as the guided journey's welcome — mascot, speech
 * bubble, one call to action — over a Toronto Zoo hero instead of the tour map.
 *
 * Copy comes from the flow deck (config/tzPlus/stops.ts), which is more recent than the Figma
 * frame; the design is the authority on layout, the deck on words.
 */
const TzPlusWelcomeModal = ({ onStart, mascotSrc }: TzPlusWelcomeModalProps) => (
  <WelcomeModalLayout
    hero={<TzPlusHero />}
    mascotSrc={mascotSrc}
    speech={TZ_PLUS_COPY.welcomeSpeech}
    buttonLabel={TZ_PLUS_COPY.welcomeButton}
    onStart={onStart}
  />
);

export default TzPlusWelcomeModal;
